"use strict";
/// <reference path="irep.js"/>

IREP.accountstatement = (function () {
    var addScrollBar = true;
    var init = function (options) {
        $("#aGotCode").click(function() {
            processCode();
        });

        var processCode = function () {
            var dataObj = { contestCode: $("#txtGotCode").val() };
            IREP.callApi("promotion/contest/processcode", "GET", dataObj).done(function (data) {
                $('#tdResult').css("color", "#333333");//set default color
                if (data !== null) {
                    if (data.contestResult.url !== null && (data.contestResult.url !== undefined)) {
                        setTimeout(function () { document.location = data.contestResult.url; }, 3000);
                    }
                    if (data.contestResult.font !== null && data.contestResult.font !== undefined) {
                        $('#tdResult').css("color", data.contestResult.font);
                    }
                    $('#tdResult').html(data.contestResult.localeText);
                    $('#trResult').slideDown("slow");
                }
                else { }
                return false;


            });
        };

        hideTours();
        hideMessages();
        hideBlogs();

        $("#divTours").on("click", function () {
            slideTo($(this).attr("data-sub"));
        });
        $("#divNotifications").on("click", function () {
            slideTo($(this).attr("data-sub"));
        });

        $("#divBlogs").on("click", function () {
            IREP.callApi("alerts/notifications/bloglog", "POST", null)
             .done(function () {
                 IREP.redirect(IREP.generateSiteLink("/blog"));
             })
            
        });

        $(".backToAccountStatement").on("click", function () {
            slideHome();
        });

        
        $(".tourLink").each(function (index) {

            if ($(this).attr("data-text") != "0") {
                $(this).show();
            }
        });


    };

    function slideHome() {
        $("#divAccountStatement").animate({ "margin-left": "0px" }, 200, function () { $(".submenu").hide(); });
    }


    function slideTo(m) {
        $("#divMessages").height($("#divAccountStatement").height());
        $("#toursTexContainer").height(($("#divMessages").height() - $(".backToAccountStatement").height()));
        $("#" + m).show();
        $("#divAccountStatement").animate({ "margin-left": "-400px" }, 200);

        if (addScrollBar) { 
            $("#divToursDetail").find('#toursTexContainer').mCustomScrollbar({

                theme: 'light',

                scrollButtons: {

                    enable: true

                }
                
            });
            addScrollBar = false;
        }
        $(".infoContainer").find(".divider").first().hide();

        
    }

    function hideTours() {
        if ($("#alertCount")[0].innerHTML == "0") {
            $("#divTours").hide();
        }
    }

    function hideMessages() {
        if ($("#messageCount")[0].innerHTML == "0") {
            $("#divSupportMessages").hide();
        }
    }

    function hideBlogs() {
        if ($("#blogCount")[0].innerHTML == "0") {
            $("#divBlogs").hide();
        }
    }

    return {
        init: init
    };
})();